<template>
  <v-container class="pa-0">
    <v-checkbox
      v-model="data.approveGdpr"
      :rules="[formRules.checked(data.approveGdpr, 'Du måste godkänna vår GDPR policy')]"
    >
      <template v-slot:label>
        <div>
          Jag godkänner
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <a
                target="_blank"
                href="https://chaffis.se/gdpr"
                @click.stop
                v-on="on"
              >
                Chaffis GDPR Policy
              </a>
            </template>
            Öppna i nytt fönster
          </v-tooltip>
        </div>
      </template>
    </v-checkbox>
  </v-container>
</template>

<script>
import { generalMixin } from '../mixins/general'
import { urlMixin } from '../mixins/url'

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  mixins: [generalMixin, urlMixin],
}
</script>

<style>

</style>